import Event from 'types/models/Event';
import EventDetail from 'types/models/EventDetail';

export const parseEvent = (event: any): Event => {
  return {
    id: event.id,
    name: event.name,
    eventStart: event.event_start,
    eventEnd: event.event_end,
    detail: event.detail ? parseEventDetail(event.detail) : undefined,
  };
};

const parseEventDetail = (detail: any): EventDetail => {
  return {
    id: detail.id,
    description: detail.description,
  };
};
